// src/project/data/triggers/acceptOrder.js
import { buildActionUrl, RIDER_ENDPOINTS, getRiderId } from '../config/apiConfig'
import Storage from '@/shared/utils/storage'

export default {
  postUrl(payload) {
    console.log("🚀 ~ payload:", payload)
    const itemData = payload.order || payload.delivery || payload
    const isPackage = itemData.type === 'package'
    
    if (isPackage) {
      if (!itemData.id) {
        console.error('[acceptOrder] Payload reçu:', payload)
        throw new Error('id est requis pour accepter un colis')
      }
      return buildActionUrl(RIDER_ENDPOINTS.PACKAGE_ASSIGN)
    }

    const orderId = payload.deliveryId || itemData.id
    if (!orderId) {
      console.error('[acceptOrder] Payload reçu:', payload)
      throw new Error('orderId est requis pour accepter une livraison')
    }
    return buildActionUrl(RIDER_ENDPOINTS.ORDER_ASSIGN)
  },
  format(payload) {
    const riderId = getRiderId()
    const userData = Storage.get('userData')
    const itemData = payload.order || payload.delivery || payload
    const isPackage = itemData.type === 'package'

    if (isPackage) {
      return {
        id: itemData.id,
        riderId: riderId,
        rider: {
          walletId: `wallet_${riderId}`,
          firstName: userData?.firstName || '',
          lastName: userData?.lastName || '',
          phone: userData?.phone || '',
          vehicle: userData?.vehicle?.type || 'motorcycle',
        },
        description: 'Livreur assigné'
      }
    }

    const orderId = payload.deliveryId || payload.order?.id || payload.delivery?.id || payload.id

    // Calcul approximatif : temps actuel + 30 minutes
    const estimatedArrival = new Date(Date.now() + 30 * 60000).toISOString();

    return {
      orderId: orderId,
      deliveryId: `dlv-${Date.now()}`,
      deliveryEstimatedArrival: estimatedArrival,
      rider: {
        walletId: `wallet_${riderId}`,
        riderId: riderId,
        name: `${userData?.firstName || ''} ${userData?.lastName || ''}`.trim(),
        phone: userData?.phone || '',
        vehicle: userData?.vehicle?.type || 'motorcycle',
      },
    }
  },
  parse(raw = {}) {
    // Réponse V3 attendue :
    // { statusCode: 200, message: "Order assigned", data: { ...orderData } }
    if (raw?.statusCode === 409) {
      return {
        statusCode:  409,
        message:  'Un rider a déjà été assigné',
        data: null,
      }
    }

    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble inaccessible',
        data: null,
      }
    }

    const delivery = raw?.data
    if (delivery?.id) {
      Storage.save('activeDeliveryId', delivery.id)
    }

    return {
      statusCode: 200,
      message: raw?.message || 'Livraison acceptée avec succès',
      data: {
        saved: true,
        delivery: delivery || null,
      },
    }
  },
}
